module.exports = __webpack_public_path__ + "static/media/06_DCV2012B.ce077843.png";